export default __webpack_public_path__ + "static/media/customer_access.32b2905e.svg";